import React, { useState, useEffect } from "react";
import "./ExplanationPage.scss";
import usg from "../Images/usg.png";
import ReturnHome from "../Components/ReturnHome";
import GreenButton from "../Components/GreenButton";
import ModalCover from "../Components/ModalCover";
import ModalButtonsDisplay from "../Components/ModalButtonsDisplay";
import { useParams, useNavigate } from "react-router";
import viewNavigate from "../Utils/viewNavigate";
import useIdle from "../Hooks/useIdle";
const QuizQuestion = (props) => {
  const isIdle = useIdle();
  let navigate = useNavigate();
  const [counter, setCounter] = useState(5);
  const [retunHome, setRetunHome] = useState(false);
  let params = useParams();
  /**@type {Array} */
  const responses = props.responses;
  const id = parseInt(params.id);
  console.log(props.responses, params.id);
  const question = responses[id];
  useEffect(() => {
    setTimeout(() => {
      if (counter >= 0) {
        setCounter(counter - 1);
      }
    }, 1000);
  }, [counter]);
  return (
    <div className="explanation-container">
      {retunHome && (
        <ModalCover>
          <ModalButtonsDisplay
            title={"Are you sure?"}
            text={"The game will end, and you can start a new session."}
            denyText={"Cancel"}
            deny={() => {
              setRetunHome(false);
            }}
            accept={() => {
              viewNavigate(navigate, `/`);
            }}
            acceptText={"Retun To Home"}
          />
        </ModalCover>
      )}
      <div className="explanation-score">
        Score: <span className="explanation-score-value">00</span>
      </div>
      <div className="explanation-central-holder">
        <h2 className="explanation-title">Did You Know?</h2>
        <p className="explanation-text">{question["Knowledge Piece Text"]}</p>
        <div className="explanation-image-container">
          {question["Knowledge Piece Image"].endsWith(".png") ||
          question["Knowledge Piece Image"].endsWith(".jpg") ? (
            <img
              src={question["Knowledge Piece Image"]}
              alt="Ultrasound Image"
            />
          ) : (
            <video loop="true" autoPlay="true" muted={true}>
              <source
                src={
                  question["video_blob_Knowledge"]
                    ? question["video_blob_Knowledge"]
                    : question["Knowledge Piece Image"]
                }
                type={`video/${question["Knowledge Piece Image"].slice(-3)}`}
              />
            </video>
          )}
        </div>
        <GreenButton
          onClick={() => {
            if (responses.length - 1 > id) {
              viewNavigate(navigate, `/QuizQuestion/${id + 1}`);
            } else {
              viewNavigate(navigate, `/IndividualResult`);
            }
          }}
          disabled={counter > 0}
        >
          {counter > 0
            ? `Wait (${counter}s)`
            : responses.length - 1 === id
            ? "See Your Score"
            : "Next Question"}{" "}
        </GreenButton>
      </div>
      <p className="knowledge-piece">{question["Kowledge Piece Note (*)"]} </p>
      <div className="bottom-actions-ex">
        <ReturnHome
          style={{ color: "white" }}
          white={true}
          onClick={() => setRetunHome(true)}
        />
      </div>
    </div>
  );
};

export default QuizQuestion;
